import { NewConvergeButton } from '../../../../presentation';
import './capacity-provider.container.scss';

import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import { CapacityProviderAllocationModal } from './capacity-provider-allocation-modal';

interface IQuotaShare {
  uuid: string | undefined;
  name: string | null | undefined;
  quotaShare: number;
}
export interface CapacityProviderContainerProps {
  isReadonly: boolean;
  QuotaShare: IQuotaShare[];
  submissionUuid: string;
}
export const CapacityProviderContainer = ({
  isReadonly,
  QuotaShare,
  submissionUuid,
}: CapacityProviderContainerProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleEditClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Stack width="82%">
        <Box className="capacity-provider-title">
          <Box>CAPACITY PROVIDER</Box>
          <Box>ALLOCATION</Box>
        </Box>
        {Array.isArray(QuotaShare) &&
          QuotaShare.map((provider) => {
            return (
              <>
                <Box className="each-row">
                  <div>{provider.name}</div>
                  <Box style={{ fontWeight: '700' }}>
                    {`${(+provider.quotaShare * 100)
                      .toFixed(2)
                      .replace(/\.?0+$/, '')} %`}
                  </Box>
                </Box>
              </>
            );
          })}

        <Box style={{ marginTop: '10px' }}>
          <NewConvergeButton
            label={'EDIT ALLOCATION'}
            variant="outlined"
            onClick={handleEditClick}
            disabled={isReadonly}
          />
        </Box>
      </Stack>
      <Stack
        style={{ borderBottom: 'solid #E0E0E0 1px', marginTop: '20px' }}
      ></Stack>

      <CapacityProviderAllocationModal
        open={modalOpen}
        onClose={handleCloseModal}
        quotaShare={QuotaShare}
        submissionUuid={submissionUuid}
      />
    </>
  );
};
